import { FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";

export default function SocialTopBar() {
  return (
    <div className="bg-primary text-light small py-1 border-bottom border-secondary">
      <div className="container d-flex align-items-center justify-content-between">
        {/* À gauche : message court (modifiable) */}
        <div className="d-none d-md-block">
          <span className="me-3">BISITELLA TRANSPORTATION LLC</span>
          <span className="text-secondary">Reliable NEMT • Mon–Sun</span>
        </div>

        {/* À droite : réseaux sociaux */}
        <div className="d-flex align-items-center gap-3">
          <a
            href="https://instagram.com/yourhandle"
            target="_blank"
            rel="noreferrer"
            className="social-link"
            aria-label="Instagram"
            title="Instagram"
          >
            <FaInstagram size={16} />
          </a>
          <a
            href="https://www.facebook.com/people/BisiTella-Transportation-LLC/61567636211677/?mibextid=wwXIfr&rdid=9fIQpoouEsk9ekVS&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Arm3SPtxW%2F%3Fmibextid%3DwwXIfr"
            target="_blank"
            rel="noreferrer"
            className="social-link"
            aria-label="Facebook"
            title="Facebook"
          >
            <FaFacebookF size={16} />
          </a>
          <a
            href="https://www.linkedin.com/company/yourcompany"
            target="_blank"
            rel="noreferrer"
            className="social-link"
            aria-label="LinkedIn"
            title="LinkedIn"
          >
            <FaLinkedinIn size={16} />
          </a>
        </div>
      </div>
    </div>
  );
}
